<template>

  <div class="group" :ref="refs[builder.config.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.config.fieldName}Title`">
      <div class="group-title">Choose your interior.</div>
      <div class="group-help">The below options are based on the measurements you have provided.</div>
    </div>

    <Selector
      :key=builder.config.fieldName
      :field-name=builder.config.fieldName
      :display-type=builder.config.displayType
      :options=builder.config.options
      :selected=builder.currentItem.specs[builder.config.fieldName]
      options-source="configOptionsForSection"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <!-- <div class="group" :ref="refs[builder.requireDoors.fieldName + 'Group']" id="requireDoors">

    <div class="group-header">
      <div class="group-title">Do you require doors and tracks?</div>
    </div>

    <Selector
      :key=builder.requireDoors.fieldName
      :field-name=builder.requireDoors.fieldName
      :display-type=builder.requireDoors.displayType
      :options=builder.requireDoors.options
      :selected=builder.currentItem.specs[builder.requireDoors.fieldName]
      options-source="requireDoorsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div> -->

  <div class="group" :ref="refs['panelsGroup']" :class="{ 's_hidden' : !builder.currentItem.specs.requireDoors }">

    <div class="group-header">
      <div class="group-title">Choose your standard door panels</div>
    </div>

    <div class="subgroup" v-for="n in builder.currentItem.specs.doors" :key="n" :ref="refs[builder['panel' + n].fieldName + 'Group']" :id="`panel${n}Id`">

      <div class="subgroup-header" :id="`${builder.panels.fieldName}${n}Title`">
        <div class="subgroup-title"><span class="visually-hidden">Choose your standard door panels: </span>Door {{ n }}</div>
      </div>

      <div class="subgroup-main">

        <Selector
          :key="`${builder['panel' + n].fieldName}`"
          :field-name="`${builder['panel' + n].fieldName}`"
          :display-type=builder.panels.displayType
          :options=builder.panels.options
          :selected="`${builder.currentItem.specs[builder['panel' + n].fieldName]}`"
          options-source="panelsOptions"
          scope="specs"
          @select-option="select"
        ></Selector>

      </div>

    </div>

  </div>

  <div class="group" :ref="refs[builder.frames.fieldName + 'Group']" :class="{'s_hidden' : !builder.currentItem.specs.requireDoors}">

    <div class="group-header" :id="`${builder.frames.fieldName}Title`">
      <div class="group-title">Choose your door frames and tracks.</div>
    </div>

    <Selector
      :key=builder.frames.fieldName
      :field-name=builder.frames.fieldName
      :display-type=builder.frames.displayType
      :options=builder.frames.options
      :selected=builder.currentItem.specs[builder.frames.fieldName]
      options-source="framesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.endPanelFinish.fieldName + 'Group']" :class="{'s_hidden' : !builder.showEndPanelFinishOptions}">

    <div class="group-header" :id="`${builder.endPanelFinish.fieldName}Title`">
      <div class="group-title">Choose your end panel finish.</div>
    </div>

    <Selector
      :key=builder.endPanelFinish.fieldName
      :field-name=builder.endPanelFinish.fieldName
      :display-type=builder.endPanelFinish.displayType
      :options=builder.endPanelFinish.options
      :selected=builder.currentItem.specs[builder.endPanelFinish.fieldName]
      options-source="endPanelFinishOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.hardware.fieldName + 'Group']" :class="{'s_hidden' : !builder.currentItem.specs.requireInternals}">

    <div class="group-header" :id="`${builder.hardware.fieldName}Title`">
      <div class="group-title">Choose your hardware options.</div>
    </div>

    <Selector
      :key=builder.hardware.fieldName
      :field-name=builder.hardware.fieldName
      :display-type=builder.hardware.displayType
      :options=builder.hardware.options
      :selected=builder.currentItem.specs[builder.hardware.fieldName]
      options-source="hardwareOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.drawerTypes.fieldName + 'Group']" :class="{'s_hidden' : !builder.currentItem.specs.requireInternals || !builder.showDrawerTypesOptions}">

    <div class="group-header" :id="`${builder.drawerTypes.fieldName}Title`">
      <div class="group-title">Choose your drawer type.</div>
    </div>

    <Selector
      :key=builder.drawerTypes.fieldName
      :field-name=builder.drawerTypes.fieldName
      :display-type=builder.drawerTypes.displayType
      :options=builder.drawerTypes.options
      :selected=builder.currentItem.specs[builder.drawerTypes.fieldName]
      options-source="drawerTypesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addRails.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addRails.fieldName}Title`">
      <div class="group-title">Would you like any additional hanging rails?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addRails.fieldName
      :field-name=builder.addRails.fieldName
      :display-type=builder.addRails.displayType
      :options=builder.addRails.options
      :selected=builder.currentItem.specs[builder.addRails.fieldName]
      options-source="addRailsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addShelves.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addShelves.fieldName}Title`">
      <div class="group-title">Would you like any additional shelves?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addShelves.fieldName
      :field-name=builder.addShelves.fieldName
      :display-type=builder.addShelves.displayType
      :options=builder.addShelves.options
      :selected=builder.currentItem.specs[builder.addShelves.fieldName]
      options-source="addShelvesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs['LabelGroup']">

    <div class="group-header" :id="`LabelTitle`">
      <div class="group-title">Label your wardrobe</div>
      <div class="group-help">Maximum 30 characters</div>
    </div>

    <Text-Input
    key="label"
    field-label="label"
    field-name="label"
    :init-value=builder.currentItem.label
    :init-touched="false"
    :placeholder="`Wardrobe ${builder.currentItem.ref}`"
    :maxlength="30"
    @update-value="updateProp"
    ></Text-Input>

  </div>

</template>

<script setup>

import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateProp(prop, val) {
  builder.setCurrentItemProp(prop, val);
}

// init refs
let refHandles = [
  'LabelGroup',
  builder.config.fieldName + 'Group',
  builder.requireDoors.fieldName + 'Group',
  builder.frames.fieldName + 'Group',
  builder.hardware.fieldName + 'Group',
  builder.drawerTypes.fieldName + 'Group',
  builder.addRails.fieldName + 'Group',
  builder.addShelves.fieldName + 'Group',
];
if (builder.currentItem.specs.doors >= 1) refHandles.push(builder.panel1.fieldName + 'Group');
if (builder.currentItem.specs.doors >= 2) refHandles.push(builder.panel2.fieldName + 'Group');
if (builder.currentItem.specs.doors >= 3) refHandles.push(builder.panel3.fieldName + 'Group');
if (builder.currentItem.specs.doors >= 4) refHandles.push(builder.panel4.fieldName + 'Group');
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
console.log('refs', refs);
</script>
